module.exports = __webpack_public_path__ + "img/profissionais.76403523.svg";